module.exports = __webpack_public_path__ + "img/quizz.65b9fd44.jpg";